import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  step: PropTypes.string,
};

const defaultProps = {
  id: '',
  required: false,
  onChange: null,
  type: 'text',
  value: '',
  className: '',
  step: '',
};

const TextInput = props => {
  const {
    name,
    id,
    type,
    placeholder,
    onChange,
    required,
    value,
    className,
    step,
    innerRef,
    ...rest
  } = props;

  return (
    <input
      {...rest}
      ref={innerRef}
      className={clsx(
        className,
        'appearance-none block w-full py-2 px-2 rounded border-none shadow-input focus:shadow-input-focus',
      )}
      step={step}
      name={name}
      id={id}
      type={type}
      placeholder={placeholder}
      onChange={e => {
        if (onChange) {
          return onChange(e);
        } else {
          return null;
        }
      }}
      required={required}
      value={value}
    />
  );
};

TextInput.propTypes = propTypes;
TextInput.defaultProps = defaultProps;

export default TextInput;
